<template>
  <TopGradientBlockLayout v-if="!currentTicket.dirty">
    <template v-slot:top>
      <TicketsChatHeader :id="currentTicket.data.id"
                         :status="currentTicket.data.status"
                         :title="currentTicket.data.title"
                         @closeTicket="applyCloseTicket(currentTicket.data.id)"
                         @goBackToTickets="backToTickets"/>
    </template>
    <TicketsChatMessages :messages="currentTicket.data.messages"
                         ref="messages"/>
    <TicketsChatMessage v-if="currentTicket.data.status !== 3"
                        @scrollChat="$refs.messages.scrollDown()"/>
  </TopGradientBlockLayout>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import TicketsChatHeader from "@/components/cabinet/Tickets/TicketsChat/TicketsChatHeader";
import TicketsChatMessages from "@/components/cabinet/Tickets/TicketsChat/TicketsChatMessages";
import TicketsChatMessage from "@/components/cabinet/Tickets/TicketsChat/TicketsChatMessage";

export default {
  name: "TheTicketsSystemChat",
  components: {TicketsChatMessage, TicketsChatHeader, TicketsChatMessages, TopGradientBlockLayout},
  computed: {
    ...mapState('cabinet/tickets', ['currentTicket']),
  },
  methods: {
    ...mapActions('cabinet/tickets', ['fetchUserTicket', 'closeTicket']),
    ...mapMutations('cabinet/tickets', ['clearCurrentTicket', 'setCurrentTicket']),
    async backToTickets() {
      await this.$router.push({name: 'ticket-system'})
      this.clearCurrentTicket()
    },
    scrollMessagesWindow() {
      this.$refs.messages.scrollDown();
    },
    async applyCloseTicket(id) {
      try {
        const res = await this.closeTicket(id);
        if (res.body.success) {
          this.setCurrentTicket(res.body.data);
        } else {
          console.log(res.body)
          this.$toasted.error('Не удалось закрыть тикет')
        }
      } catch (e) {
        console.log(e)
        this.$toasted.error('Не удалось закрыть тикет')
      }

    }
  },
  async created() {
    if (!this.currentTicket.data) {
      const {ticketId} = this.$route.params
      await this.fetchUserTicket(+ticketId)
    }
  }
}
</script>